import { SeoFragmentPage } from '@website/components/seo';

export default function useExtractSeoProps(data: SeoFragmentPage) {
  const { datoCmsSeo } = data || {};
  const {
    canonicalLink,
    customTags,
    fadeslideshowreviews,
    images,
    reviews,
    seoMetaTags,
    seoRichStructuredData,
  } = datoCmsSeo || {};

  return {
    canonicalLink,
    customTags,
    fadeslideshowreviews,
    images,
    reviews,
    seoMetaTags,
    seoRichStructuredData,
  };
}
